module.exports = __webpack_public_path__ + "static/media/manuel4.b822311f.png";